module.exports = __webpack_public_path__ + "img/face-sad-tear.6029cd44.svg";